
document.addEventListener("DOMContentLoaded", function () {
  const breadcrumb = document.querySelector('.product__breadcrumb');
  const featuredProduct = document.querySelector('.featured-product');

  if (breadcrumb && featuredProduct) {
    featuredProduct.parentNode.insertBefore(breadcrumb, featuredProduct);
  }
});






















/* helia codes */
document.addEventListener("DOMContentLoaded", function () {
  const mapApp = document.querySelector("#mapApp");
  const form = document.querySelector("main-cart > div > form");

  if (mapApp && form) {
    form.insertAdjacentElement("afterend", mapApp);
  }
});








document.addEventListener("DOMContentLoaded", function () {
  const salePrices = document.querySelectorAll(".price__sale");

  salePrices.forEach(function (salePrice) {
    if (!salePrice.textContent.trim().startsWith("RRP:")) {
      salePrice.insertAdjacentText("afterbegin", "RRP: ");
    }
  });
});







function toggleProductGrid() {
  const collectionSection = document.querySelector("#shopify-section-template--29359266267474__main-collection");
  const productGrid = collectionSection ? collectionSection.querySelector("#ProductGridContainer") : null;
  const featuredSection = document.querySelector("#shopify-section-template--29359266267474__featured_collection_nrDpUm");

  if (!collectionSection || !productGrid || !featuredSection) return;

  const products = collectionSection.querySelectorAll(".product-card");

  if (products.length === 0) {
    productGrid.style.display = "none";      // eltünteti a gridet
    featuredSection.style.display = "block"; // mutatja a featured szekciót
  } else {
    productGrid.style.display = "flex";      // vagy eredeti flex/grid display
    featuredSection.style.display = "none";  // elrejti a featured szekciót
  }
}

// futtatás betöltéskor és Shopify section frissítéskor
document.addEventListener("DOMContentLoaded", toggleProductGrid);
document.addEventListener("shopify:section:load", toggleProductGrid);






document.addEventListener("DOMContentLoaded", function() {
  const videos = document.querySelectorAll("video[autoplay]");
  videos.forEach(video => {
    video.muted = true;
    video.play().catch(()=>{});
  });
});








document.addEventListener("DOMContentLoaded", function () {
  const breadcrumb = document.querySelector('.product__breadcrumb');
  const featuredProduct = document.querySelector('.featured-product');

  if (breadcrumb && featuredProduct) {
    featuredProduct.parentNode.insertBefore(breadcrumb, featuredProduct);
  }
});



// ÜRES SZEKCIÓK

document.addEventListener("DOMContentLoaded", function () {
  const promoCards = document.querySelectorAll(".product-card--promo");

  promoCards.forEach(card => {
    const img = card.querySelector("picture img");

    // Ha nincs kép vagy nincs src → elrejtjük
    if (!img || !img.getAttribute("src")) {
      card.style.display = "none";
    }
  });
});



document.addEventListener("DOMContentLoaded", function () {
  if (
  !document.body.classList.contains("template-product") &&
  !document.body.classList.contains("template-article")
) return;

  const sections = document.querySelectorAll(".shopify-section");

  sections.forEach(section => {

    const images = section.querySelectorAll("img");
    const svgs = section.querySelectorAll("svg.placeholder");
    const videos = section.querySelectorAll("video");
    const iframes = section.querySelectorAll("iframe");

    let hasRealImage = false;
    let hasRealVideo = false;

    images.forEach(img => {
      const src = img.getAttribute("src") || "";
      const isPlaceholder =
        src.includes("no-image") ||
        src.includes("placeholder") ||
        src.includes("data:image");

      if (!isPlaceholder) {
        hasRealImage = true;
      }
    });

    // HTML5 video
    videos.forEach(video => {
      if (video.querySelector("source") || video.getAttribute("src")) {
        hasRealVideo = true;
      }
    });

    // YouTube / Vimeo iframe
    iframes.forEach(iframe => {
      const src = iframe.getAttribute("src") || "";

      if (
        src.includes("youtube.com/embed/") &&
        !src.includes("embed/?")
      ) {
        hasRealVideo = true;
      }

      if (src.includes("player.vimeo.com")) {
        hasRealVideo = true;
      }
    });

    const onlyPlaceholderSVG =
      images.length === 0 &&
      svgs.length > 0 &&
      !hasRealVideo;

    const noRealMedia =
      !hasRealImage &&
      !hasRealVideo &&
      (images.length > 0 || svgs.length > 0);

    const blogEmptyMessage = section.querySelector(".rte");
    let isEmptyBlogSection = false;

    if (blogEmptyMessage) {
      const text = blogEmptyMessage.textContent.trim();
      if (text.includes("Nincsenek kiválasztott blogbejegyzések")) {
        isEmptyBlogSection = true;
      }
    }

    // 🔥 plusz check: video hero iframe nélkül
    const isVideoHero = section.querySelector(".video-hero");
    if (isVideoHero && !hasRealVideo) {
      section.style.display = "none";
      return;
    }

    if (onlyPlaceholderSVG || noRealMedia || isEmptyBlogSection) {
      section.style.display = "none";
    }

  });

  // Scrollspy sync
  const scrollSpyLinks = document.querySelectorAll(".scrollspy-link");

  scrollSpyLinks.forEach(link => {
    const targetId = link.getAttribute("data-target");
    if (!targetId) return;

    const targetSection = document.getElementById(targetId);

    if (!targetSection || targetSection.style.display === "none") {
      const listItem = link.closest(".scrollspy-item");
      if (listItem) listItem.remove();
    }
  });

});

//COLLECTION description
document.addEventListener("DOMContentLoaded", function () {

  // Csak kollekció oldalon fusson
  if (!document.body.classList.contains('template-collection')) return;

  // Összes rich text section kiválasztása
  const sections = document.querySelectorAll('.shopify-section');

  sections.forEach(section => {

    const richText = section.querySelector('.rich-text');
    if (!richText) return;

    const rte = section.querySelector('.rte');

    // Ha nincs .rte vagy üres
    if (!rte || rte.innerText.trim() === '') {
      section.style.display = 'none';
    }

  });

});



document.addEventListener("DOMContentLoaded", function () {
  const section = document.querySelector('#shopify-section-template--28594193662290__featured_collection_KtLH3F');
  if (!section) return;

  const productCards = section.querySelectorAll('.product-card');
  if (!productCards.length) {
    section.style.display = 'none';
    return;
  }

  let realProductFound = false;

  productCards.forEach(card => {
    const link = card.querySelector('.product-card__title');
    if (link && link.getAttribute('href') && link.getAttribute('href') !== '#') {
      realProductFound = true;
    }
  });

  if (!realProductFound) {
    section.style.display = 'none';
  }
});











// EMAIL POPUP (több email támogatással)
document.addEventListener("DOMContentLoaded", function () {

  // --- Nyelv lekérése ---
  const lang = document.documentElement.lang; // pl. 'hu', 'en'

  // --- Szövegek nyelvenként ---
  const texts = {
    hu: {
      copy: "Másolás vágólapra",
      copied: "Email cím másolva a vágólapra!"
    },
    en: {
      copy: "Copy to clipboard",
      copied: "Email address copied to clipboard!"
    }
  };

  const t = texts[lang] || texts.hu;

  // --- Email selector (MOST MÁR MINDEN mailto linkre) ---
  const emailLinks = document.querySelectorAll('a[href^="mailto:"]');
  if (!emailLinks.length) return;

  // --- Overlay létrehozása ---
  const overlay = document.createElement("div");
  overlay.classList.add("overlay-popup");
  overlay.style.display = "none";
  document.body.appendChild(overlay);

  // --- Popup létrehozása ---
  const popup = document.createElement("div");
  popup.classList.add("popup");
  popup.style.display = "none";
  popup.innerHTML = `
    <button class="popup-close">X</button>
    <a class="popup-email" href="#"></a>
    <button class="copy-btn">${t.copy}</button>
  `;
  document.body.appendChild(popup);

  const closeButton = popup.querySelector(".popup-close");
  const copyButton = popup.querySelector(".copy-btn");
  const popupEmail = popup.querySelector(".popup-email");

  let currentEmail = "";

  function openPopup(event) {
    event.preventDefault();

    currentEmail = this.getAttribute("href").replace("mailto:", "").trim();

    popupEmail.textContent = currentEmail;
    popupEmail.setAttribute("href", "mailto:" + currentEmail);

    overlay.style.display = "block";
    popup.style.display = "block";
  }

  function closePopup() {
    overlay.style.display = "none";
    popup.style.display = "none";
  }

  // --- MINDEN mailto linkre esemény ---
  emailLinks.forEach(link => {
    link.addEventListener("click", openPopup);
  });

  // --- Bezárás ---
  closeButton.addEventListener("click", closePopup);
  overlay.addEventListener("click", closePopup);

  // --- Másolás ---
  copyButton.addEventListener("click", () => {
    navigator.clipboard.writeText(currentEmail).then(() => {
      alert(t.copied);
    }).catch(() => {
      alert("Copy failed");
    });
  });

});



document.addEventListener("DOMContentLoaded", function () {

  const sectionId = "shopify-section-template--29162702602578__main-blog";
  const section = document.getElementById(sectionId);
  if (!section) return;

  const isEnglish = document.documentElement.lang.startsWith("en");

  // CSAK ebben a sectionben, és csak az article-card footer link
  const links = section.querySelectorAll('.article-card__content > p > a.link');

  links.forEach(link => {

    // Extra védelem: csak az "Elolvasom" típusú linket módosítsuk
    if (!link.textContent.trim().toLowerCase().includes("elolvasom")) return;

    const originalHref = link.getAttribute("href");

    const label = isEnglish ? "I'm interested" : "Érdekel";

    // Class reset CSAK ezen az elemen
    link.classList.remove("link");
    link.classList.add(
      "button",
      "button--primary",
      "button--md",
      "icon-with-text"
    );

    link.setAttribute("is", "hover-link");

    link.innerHTML = `

      <span class="btn-text">
        ${label}
        <svg class="icon icon-arrow-right icon-sm transform" viewBox="0 0 21 20" stroke="currentColor" fill="none" xmlns="http://www.w3.org/2000/svg" role="presentation">
          <path stroke-linecap="round" stroke-linejoin="round" d="M3 10H18M18 10L12.1667 4.16675M18 10L12.1667 15.8334"></path>
        </svg>
      </span>
    `;

    link.setAttribute("href", originalHref);

  });

});


